import { IconButton, InputAdornment, SxProps, useTheme } from '@mui/material';
import React, { ChangeEvent, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { FlexyTextField } from '../FlexyTextField';

export type SearchBarProps = {
    className?: string;
    value?: string;
    placeholder?: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onDelete?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    sx?: SxProps;
};

export const SearchBar: React.FunctionComponent<SearchBarProps> = function (props) {
    const theme = useTheme();
    const { className, value, placeholder, onChange = () => {}, onDelete, sx } = props;

    const [valueField, setValueField] = useState<string>(value || '');
    React.useEffect(() => {
        setValueField(value || '');
    }, [value]);

    return (
        <FlexyTextField
            className={className}
            variant="outlined"
            value={valueField}
            onChange={onChange}
            placeholder={placeholder}
            sx={{ width: '100%', marginTop: '25px', ...sx }}
            inputMode="search"
            InputProps={{
                sx: { borderRadius: '15px', backgroundColor: theme.palette.background.paper },
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                ),
                endAdornment:
                    onDelete && valueField ? (
                        <InputAdornment position="end">
                            <IconButton onClick={onDelete}>
                                <FaOptionIcon
                                    sx={{ fontSize: '14px' }}
                                    icon={['fasl', 'times']}
                                />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
            }}
        />
    );
};
